import apiClient from '@u/apiClient'
import actionsChiftInvoicing from './actions.chift_invoicing'
import actionsChiftAccounting from './actions.chift_accounting'

export default {
  ...actionsChiftInvoicing,
  ...actionsChiftAccounting,
  fetchAccountingDiaryList({ commit }) {
    return new Promise((resolve, reject) => {
      apiClient
        .get('accounting-diary')
        .then(async (response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  // region Fetch
  fetchAccountingDiaryByID({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`accounting-diary/${payload.id}`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchNewAccountingDiary({ commit }) {
    return new Promise((resolve, reject) => {
      apiClient
        .get('model/new?model=accountingDiary')
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  // endregion

  // region store
  storeAccountingDiary({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .post('accounting-diary', payload.accounting_diary)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region update
  updateAccountingDiary({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .put(`accounting-diary/${payload.id}`, payload.accounting_diary)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  async duplicateAccountingDiary({ commit }, payload) {
    return new Promise((resolve, reject) => {
        apiClient
      .put(`accounting-diary/duplicate/${payload.id}`)
      .then(async (response) => { resolve(response.data) })
      .catch((reason) => {
        console.error('duplicateAccountingDiary', reason)
      })
    })
  },
  // endregion

  // region delete
  deleteAccountingDiaryById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .delete(`accounting-diary/${payload.id}`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region undoDelete
  undoDeleteAccountingDiaryById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`accounting-diary/${payload.id}/undo-delete`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
  // endregion
}
